import { getSessionAuthentication, rms2BasePath } from '../common/Api';

interface FetchOptions {
    method: string;
    headers: Record<string, string>;
    body?: string;
}

function getHeaders(): Record<string, string> {
    const auth = getSessionAuthentication();
    return {
        'Content-Type': 'application/json',
        'Authorization': auth.token,
        'x-cleverapps-tenant': auth.tenantStringIdentifier,
    };
}

async function rms2Fetch<T>(path: string, options?: Partial<FetchOptions>): Promise<T> {
    const response = await fetch(rms2BasePath + path, {
        method: options?.method ?? 'GET',
        headers: getHeaders(),
        body: options?.body,
    });
    if (!response.ok) {
        throw new Error(`API error: ${response.status} ${response.statusText}`);
    }
    const text = await response.text();
    return text ? JSON.parse(text) : null;
}

// Types

export interface Variant {
    id: number;
    variantName: string;
}

export interface VariantDetail {
    id: number;
    variantDetailName: string;
    statisticName: string;
    sortOrder: number;
}

export interface VariantDetailsResponse {
    data: {
        results: VariantDetail[];
        page: number;
        limit: number;
        total: number;
    };
}

// API calls

export async function getVariant(id: number): Promise<Variant> {
    return rms2Fetch<Variant>(`variants/${id}`);
}

export async function getVariantDetails(
    variantId: number,
    page: number,
    filter: string,
    pageSize: number
): Promise<VariantDetailsResponse> {
    const params = new URLSearchParams();
    params.set('variantId', String(variantId));
    if (page > 1) params.set('page', String(page));
    if (filter) params.set('filter', filter);
    if (pageSize > 0) params.set('pageSize', String(pageSize));

    return rms2Fetch<VariantDetailsResponse>(`variants/details?${params.toString()}`);
}

export async function updateVariantDetails(details: VariantDetail[]): Promise<void> {
    await rms2Fetch<void>('variants/details', {
        method: 'PUT',
        body: JSON.stringify(details),
    });
}
